import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-168">
      <div className="max-w-4xl mx-auto" data-id="element-169">
        <div className="bg-brand-dark text-white rounded-2xl md:rounded-3xl p-8 sm:p-12 border-2 border-brand-gold relative shadow-md md:shadow-2xl overflow-hidden" data-id="element-170">
          {/* Background subtle pattern/glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-brand-gold/5 blur-3xl rounded-full pointer-events-none hidden md:block" data-id="element-171"></div>

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-172">
            <div className="w-20 h-20 bg-brand-gold rounded-full flex items-center justify-center mb-8 shadow-lg" data-id="element-173">
              <ShieldCheck className="w-10 h-10 text-brand-dark" data-id="element-174" />
            </div>

            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-gold mb-8" data-id="element-175">
              La Garantía Zeklo: El riesgo es nuestro. El resultado es tuyo.
            </h2>

            <div className="space-y-6 text-lg sm:text-xl text-gray-200 font-serif max-w-2xl mx-auto leading-relaxed" data-id="element-176">
              <p data-id="element-177">Tienes 15 días para probarlo todo.</p>
              <p data-id="element-178">
                Sigue el protocolo. Aplica la Hoja de Ruta. Come con el
                Recetario. Identifica tus saboteadores.
              </p>
              <p data-id="element-179">
                Si en 15 días no has notado diferencia en tu vientre, tu energía
                o tu claridad mental — te devolvemos el 100% de tu dinero.
              </p>
              <p data-id="element-180">
                Sin preguntas. Sin formularios de 47 páginas. Sin esperas de 30
                días. Te hacemos la devolución en 24 horas.
              </p>
              <p className="font-bold text-white pt-4" data-id="element-181">
                ¿Por qué ofrecemos esto? Porque sabemos que funciona. Y
                preferimos que lo compruebes tú misma.
              </p>
            </div>

            <div className="mt-10 pt-8 border-t border-brand-gold/30 w-full" data-id="element-182">
              <p className="text-xl sm:text-2xl font-serif italic text-brand-gold font-medium" data-id="element-183">
                "Inviertes 26€. El riesgo es cero. La única decisión real es si
                quieres seguir igual mañana."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}